import * as Yup from 'yup';

export const forgotPasswordValidationSchema = Yup.object().shape({
  email: Yup.string().trim().email('Enter a valid email').required('Enter your email'),
});
